(function ($) {

    var delayTimer;
    var entities = { result: [], totalMatching: 0 };
    var map;
    var markers;

    var source = $("#entity-template").html();
    var template = Handlebars.compile(source);
    var districts = [];
    var projectstatus = [];
    var projecttype = [];
    var projectcategory = [];
    var query = "";

    map = initializeMap("entities-map", 58.97, 5.74, 12);

    // Use received data to bind to view
    function entityShowResult(data) {
        entities.Items = data.Items;
        if (map == null)
            return;

        if (markers != null)
            map.removeLayer(markers);

        markers = L.markerClusterGroup();
        markers.clearLayers();

        const markerIcon = L.icon({
            // specify the path here
            iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
            shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png",
            // Uten disse setter Leaflet ingen margin, og ikonets øverste venstre hjørne
            // havner på koordinatet i stedet for nålespissen. Samme mål som standardikonet
            // map.js bruker på entitetssidene.
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });


        $(entities.Items).each(function (index, item) {

            // Uten koordinater ville markøren havnet på 0,0, utenfor Afrika
            if (!item.Latitude || !item.Longitude) {
                return;
            }

            // create the marker
            var marker = L.marker([item.Latitude, item.Longitude], { icon: markerIcon });
            marker.bindPopup('' +
                '<strong><a href="' + item.Url + '">' + item.Name + '</a></strong><br />' +
                '<a href="https://maps.google.com/?daddr=' + item.Latitude + ',' + item.Longitude + '" target="_new" class="external">Se veibeskrivelse</a>'
            );
            markers.addLayer(marker);
        });
        map.addLayer(markers);
        // Treff uten koordinater gir ingen markør, og tomme bounds får Leaflet til å kaste.
        if (markers.getLayers().length) {
            map.fitBounds(markers.getBounds(), { padding: [20, 20] });
        }

        entities.TotalMatching = data.TotalMatching;
        var html = template(entities);
        $("#entities-result").html(html);
    }

    // Search for string and handle received data
    function entitySearch(query, filters) {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function () {

            // Update url with query
            if (history.pushState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?q=' + query;

                // Add ownertype selection
                if (filters.projectstatus.length)
                    newurl = newurl + "&ps=" + filters.projectstatus;

                if (filters.projecttype.length)
                    newurl = newurl + "&pt=" + filters.projecttype;

                if (filters.projectcategory.length)
                    newurl = newurl + "&pc=" + filters.projectcategory;

                // Add districts selection
                if (filters.districts.length)
                    newurl = newurl + "&d=" + filters.districts;

                window.history.pushState({ path: newurl }, '', newurl);
            }
            
            $.getJSON(entityApiUrl, { query: query, districts: filters.districts, projectstatus: filters.projectstatus, projecttype: filters.projecttype, projectcategory: filters.projectcategory }, entityShowResult);
        }, 250);
    }

    function getFilters() {
        return {
            districts: districts.join(),
            projectstatus: projectstatus.join(),
            projecttype: projecttype.join(),
            projectcategory: projectcategory.join()
        }
    }

    // Handle search input text input
    var entitySearchInputTimer;
    $('#search-entity-form .entity-search-input').on('input', function () {
        query = $(this).val();

        var filters = getFilters();
        entitySearch(query, filters);
    });

    // Trigger input event if value is present
    if ($('#search-entity-form .entity-search-input').val() !== '') {
        $("#search-entity-form .entity-search-input").trigger("input");
    }

    // Handle button search
    $('#search-entity-form input[type=submit]').click(function (e) {
        var val = $(this).siblings(".entity-search-input").val();
        query = val;
               
        var filters = getFilters();
        entitySearch(query, filters);
    });

    $(".filter-district input[type=checkbox]").change(function () {

        if ($(this).is(":checked")) {
            districts.push($(this).val());
        } else {
            var index = districts.indexOf($(this).val());    // <-- Not supported in <IE9
            if (index !== -1) {
                districts.splice(index, 1);
            }
        }
                
        var filters = getFilters();
        entitySearch(query, filters);
    });

    $(".filter-projectstatus input[type=checkbox]").change(function () {

        if ($(this).is(":checked")) {
            projectstatus.push($(this).val());
        } else {
            var index = projectstatus.indexOf($(this).val());    // <-- Not supported in <IE9
            if (index !== -1) {
                projectstatus.splice(index, 1);
            }
        }

        var filters = getFilters();
        entitySearch(query, filters);
    });

    $(".filter-projecttype input[type=checkbox]").change(function () {

        if ($(this).is(":checked")) {
            projecttype.push($(this).val());
        } else {
            var index = projecttype.indexOf($(this).val());    // <-- Not supported in <IE9
            if (index !== -1) {
                projecttype.splice(index, 1);
            }
        }

        var filters = getFilters();
        entitySearch(query, filters);
    });

    $(".filter-projectcategory input[type=checkbox]").change(function () {

        if ($(this).is(":checked")) {
            projectcategory.push($(this).val());
        } else {
            var index = projectcategory.indexOf($(this).val());    // <-- Not supported in <IE9
            if (index !== -1) {
                projectcategory.splice(index, 1);
            }
        }

        var filters = getFilters();
        entitySearch(query, filters);
    });

    // Search for blank on start
    $(document).ready(function () {

        $('.filter-district input[type=checkbox]').each(function () {
            if ($(this).is(":checked")) {
                districts.push($(this).val());
            } else {
                var index = districts.indexOf($(this).val());    // <-- Not supported in <IE9
                if (index !== -1) {
                    districts.splice(index, 1);
                }
            }
        });

        $('.filter-projectstatus input[type=checkbox]').each(function () {
            if ($(this).is(":checked")) {
                projectstatus.push($(this).val());
            } else {
                var index = projectstatus.indexOf($(this).val());    // <-- Not supported in <IE9
                if (index !== -1) {
                    projectstatus.splice(index, 1);
                }
            }
        });

        $('.filter-projecttype input[type=checkbox]').each(function () {
            if ($(this).is(":checked")) {
                projecttype.push($(this).val());
            } else {
                var index = projecttype.indexOf($(this).val());    // <-- Not supported in <IE9
                if (index !== -1) {
                    projecttype.splice(index, 1);
                }
            }
        });

        $('.filter-projectcategory input[type=checkbox]').each(function () {
            if ($(this).is(":checked")) {
                projectcategory.push($(this).val());
            } else {
                var index = projectcategory.indexOf($(this).val());    // <-- Not supported in <IE9
                if (index !== -1) {
                    projectcategory.splice(index, 1);
                }
            }
        });
               
        var filters = getFilters();
        entitySearch(query, filters);
    });

})(jQuery);
